//---css
import 'vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css'
import 'vuetify/dist/vuetify.min.css'
import 'swiper/css/swiper.min.css'
import "vue-snotify/styles/material.scss"
import 'normalize.css'
//---END css

import Vue from 'vue'
import App from './App.vue'

import Vuex from 'vuex';
import router from './router'
import store from './store'

import Vuetify from 'vuetify'
import {vuetifyOptions} from './utils/vuetify-options'

import PerfectScrollbar from 'vue2-perfect-scrollbar'
import {snotifyOptions} from './utils/snotify-options'
import Snotify from 'vue-snotify'
import { VueMaskDirective } from 'v-mask'
import './utils/vue-filters.js'
import './utils/http'
import './utils/googleAPI'

Vue.config.productionTip = (process.env.VUE_APP_PRODUCTION_TIP !== undefined) ? process.env.VUE_APP_PRODUCTION_TIP : true;
Vue.config.ignoredElements = ['noindex']

Vue.use(Vuex);

Vue.use(Vuetify);
let vuetify = new Vuetify(vuetifyOptions);

Vue.use(PerfectScrollbar);
Vue.use(Snotify, snotifyOptions);

Vue.directive('mask', VueMaskDirective);

new Vue({
  router,
  store,
  vuetify,
  beforeCreate() {
    Vue.$snotify = this.$snotify;
  },
  render: h => h(App)
}).$mount('#app');
